export default [
    {
        name:'version',
        path:'version',
        meta: { title: '版本维护' },
        component: ()=>import('@/pages/version/index.vue')
    }
]